'use client';

import React__default from 'react';

var closeIcon = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.fill, fill = _c === void 0 ? '' : _c;
    return (React__default.createElement("svg", { style: style, fill: fill, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 50 50', width: '50px', height: '50px' },
        React__default.createElement("path", { d: 'M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z' })));
};

export { closeIcon as default };
//# sourceMappingURL=deleteIcon.js.map
